<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card style="min-width: 320px">
      <v-toolbar dense class="">
        <v-toolbar-title>Billing Name as per Xero</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card>
          <v-card-text>
            <v-autocomplete
              prepend-icon="groups"
              :items="clientGroups"
              label="Select Group"
              hide-details
              item-text="Name"
              v-model="selectedGroup"
              chips
              return-object
            >
            </v-autocomplete>
            <v-row class="pt-2">
              <v-col>
                <v-list-item class="pa-0">
                  <v-list-item-content>
                    <!-- <v-list-item-title class="pb-1">Following Clients will be added to group.</v-list-item-title> -->
                    <v-list-item-subtitle :key="index" v-for="(client, index) in selectedClients"><v-icon color="green" small>mdi-check</v-icon> {{client.name}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="success" :disabled="!selectedGroup" @click="saveClientGroup">Save changes</v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import clientAPIs from './clientAPIs';
import xeroAPIS from '../Xero/XeroAPIs'
export default {
  name: 'ClientGroupModal',
  props: {
    selectedClients: Array,
    value: Boolean
  },
  data () {
    return {
      clientGroups: [],
      selectedGroup: '',
      newClientGroup: '',
      loading: false
    }
  },
  watch: {
    value: function(newValue) {
      if (newValue === true) {
        this.getClientGroups() // refresh client groups on modal open
      }
    }
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
    async saveClientGroup() {
      const formData = this.buildFormData()
      this.loading = true
      try {
        let response = await clientAPIs.addClientGroup(formData)
        if (response) {
          this.getClientGroups()
          // Return the newly added data to parent component
          this.loading = false;
          this.$swal({
            title: 'Successful',
            text: `Clients are added to (${response.group.Name || '-'})`,
            type: 'success'
          }).then(() => {
            this.$emit('input')
            this.$emit('saved', true);
          });
        }
      } catch (error) {
        this.loading = false;
        this.$swal({
          title: 'Error',
          text: error,
          type: 'error'
        });
        console.log('error', error);
      }
    },
    buildFormData() {
      // if (typeof this.selectedGroup === 'string') {
      //   this.selectedGroup = {id: 0, name: this.selectedGroup}
      // }
      let formData = new FormData();
      formData.append('group', JSON.stringify(this.selectedGroup));
      formData.append('clients', JSON.stringify(this.selectedClients.map(c => c.id)));
      return formData
    },
    closeModal() {
      this.$emit('input')
      this.selectedGroup = ''
    },
    async getClientGroups() {
      try {
        const resp = await xeroAPIS.getXeroContacts();
        if (resp.data.success) {
          this.clientGroups = resp.data.data;
          this.selectedGroup = ''
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientGroupModal.vue?d2328ae0